/**
 * Tween loop type
 */
export enum LoopType {
  CLAMP,
  REPEAT,
  YOYO
}
